import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import QrCodeWithLogo from "qr-code-with-logo";
import PGDElement, { Platforms } from "./pg.element";

export type ErrorCorrectionLevel = "L" | "M" | "Q" | "H";
@customElement("pg-qrcode")
export class PGDQRCodeElement extends LitElement implements PGDElement {
  @property({ type: String }) content: string = "";
  @property({ type: String }) width = 250;
  @property({ type: String }) logo: string = "";
  @property({ type: String }) errCorrectionLevel: ErrorCorrectionLevel = "Q";
  @property({ type: String }) colorDark = "#000000ff";
  @property({ type: String }) colorLight = "#ffffff";
  platform(): string[] {
    return ["web", "mobile"];
  }
  isSupport(platform: Platforms): boolean {
    return this.platform().indexOf(platform) > -1;
  }
  render() {
    return html`
      <style>
        :host {
          display: inline-table !important;
          min-width: 150px;
          min-height: 150px;
          width: ${this.width}px;
        }
        #canvas {
          min-width: 150px;
          min-height: 150px;
          pointer-events: none;
        }
      </style>
      <canvas id="canvas"></canvas>
    `;
  }
  firstUpdated() {
    this.generateQRCode();
  }

  updated() {
    this.generateQRCode();
  }

  generateQRCode() {
    var canvasEle = this.renderRoot.querySelector("canvas");
    QrCodeWithLogo.toCanvas({
      canvas: canvasEle!,
      logo: this.logo
        ? {
            src: this.logo,
            borderSize: 0,
          }
        : undefined,
      content: this.content ? this.content : "https://oneweb.tech/",
      width: this.width,
      nodeQrCodeOptions: {
        errorCorrectionLevel: this.errCorrectionLevel,
        color: {
          dark: this.colorDark,
          light: this.colorLight,
        },
      },
    });
  }
}
